import { render, staticRenderFns } from "./AddEditSubcategoryForm.vue?vue&type=template&id=39f707e2"
import script from "./AddEditSubcategoryForm.vue?vue&type=script&lang=js"
export * from "./AddEditSubcategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports